import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import TotalSales from './totalSales';
import TaxesCollected from './taxesCollected';
import AmountsTable from './amountsTable';
import {
  getProductSalesReport,
  getProductSalesSum,
  getProductRefunds,
} from '../selectors';
import { canUseGiftCards } from '../../../auth/selectors';

const ProductReport = ({ barberSummary, refundAmount, showGiftCards, barberReports }) => (
  <div>
    {<div display-if={barberReports.length}>No data for selected date range and filters</div>}
    <h3>Total Product Sales</h3>
    <TotalSales report={barberSummary} showGiftCards={showGiftCards} />
    <h3>Taxes Collected &amp; Refunds</h3>
    <TaxesCollected report={barberSummary} refundAmount={refundAmount} />
    <AmountsTable
      barberReports={barberReports}
      summary={barberSummary}
      showGiftCards={showGiftCards}
    />
  </div>
);

const mapStateToProps = state => ({
  barberReports: getProductSalesReport(state),
  barberSummary: getProductSalesSum(state),
  refundAmount: getProductRefunds(state),
  showGiftCards: canUseGiftCards(state),
});

ProductReport.propTypes = {
  barberReports: PropTypes.array.isRequired,
  refundAmount: PropTypes.number.isRequired,
  showGiftCards: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps)(ProductReport);
